// 后端 API 封装：token 注入 + 统一错误处理 + SSE 流式聊天

const BASE_URL = 'https://api.xishia.com/app';

let token = localStorage.getItem('xishia_authToken');

export function setToken(t: string | null) {
  token = t;
  if (t) localStorage.setItem('xishia_authToken', t);
  else localStorage.removeItem('xishia_authToken');
}

export function getToken() {
  return token;
}

export async function request<T = any>(path: string, options: RequestInit = {}): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...options.headers as Record<string, string>,
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${path}`, { ...options, headers });
  const data = await res.json();
  if (data.code !== 0) throw new Error(data.message || '请求失败');
  return data.data;
}

export const api = {
  get: <T = any>(path: string) => request<T>(path),
  post: <T = any>(path: string, body?: unknown) =>
    request<T>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  put: <T = any>(path: string, body?: unknown) =>
    request<T>(path, { method: 'PUT', body: body ? JSON.stringify(body) : undefined }),
  delete: <T = any>(path: string) => request<T>(path, { method: 'DELETE' }),
};

// SSE 流式聊天专用（不能用 request，要读流）
export async function chatStream(
  eventId: number,
  text: string,
  mentions: string[],
  handlers: {
    onDelta: (godId: string, delta: string) => void;
    onDone: (reply: {
      messageId: number;
      godId: string;
      content: string;
      action?: { tool: string; payload: any; status: string };
    }) => void;
    onError: (message: string) => void;
  },
): Promise<void> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}/chat/${eventId}/chat`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ text, mentions }),
  });
  if (!res.ok || !res.body) {
    const errData = await res.json().catch(() => ({}));
    throw new Error(errData.message || `请求失败 ${res.status}`);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let currentEvent = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop() || '';
    for (const line of lines) {
      if (line.startsWith('event:')) {
        currentEvent = line.slice(6).trim();
        continue;
      }
      if (line.startsWith('data:')) {
        const dataStr = line.slice(5).trim();
        if (!dataStr) continue;
        try {
          const data = JSON.parse(dataStr);
          if (currentEvent === 'delta') handlers.onDelta(data.godId, data.delta);
          else if (currentEvent === 'done') handlers.onDone(data);
          else if (currentEvent === 'error') handlers.onError(data.message);
        } catch {
          /* skip malformed chunk */
        }
      }
    }
  }
}
